import DelBox from '../comps/DelBox';
import AddDepart from '../models/AddDepart';
import { useEffect, useState, useMemo } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';

const Departments = () => {
  const [formData, setFormData] = useState({
    l1: [],
    cat_type: 'department',
    page_no: 0,
    alertMsg: '',
    alertMsgTyp: '',
    search_key: '',
    isAlert: false,
  });
  const [isAdmin, setIsAdmin] = useState(false);
  const [ldata, setLdata] = useState(null);
  const [editItem, setEditItem] = useState(null);

  const initData = async () => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const fd = new FormData();
      fd.append('cat_type', formData.cat_type + "");
      fd.append('page_no', formData.page_no + "");
      fd.append('search_key', formData.search_key + "");
      fd.append('par_by', 1 + "");
      try {
        const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        if (response.data.status) {
          var records = response.data.records;
          if (records != null && records != undefined) {
            setFormData(prev => ({ ...prev, l1: records }));
          }
        }
      } catch (error) { }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const delItem = async (editItem) => {
    const fd = new FormData();
    fd.append('cat_id', editItem.cat_id + "");
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.delCatUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data.status) {
        initData();
        toast.success("Department deleted successfully");
      }
    } catch (error) { }
  };

  const handleAddDepart = () => {
    formData.page_no = 0;
    initData();
  };

  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
    const userData = JSON.parse(sessionStorage.getItem("ldata"));
    const roleId = userData?.role_id;
    setIsAdmin(roleId === 1 || roleId === "1");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
      initData();
    }
  }, []);

  const filteredList = useMemo(() => {
    if (formData.search_key.trim() === "") return formData.l1;
    return formData.l1.filter(item =>
      item.cat_name?.toLowerCase().includes(formData.search_key.toLowerCase())
    );
  }, [formData.l1, formData.search_key]);

  // DataTable columns
  const columns = [
    {
      name: 'SN',
      selector: (row, index) => index + 1,
      sortable: false,
      width: '80px',
    },
    {
      name: 'Department',
      selector: row => row.cat_name,
      sortable: true,
    },
    {
      name: 'Action',
      cell: (row) => (
        <ul className="list-inline hstack gap-2 mb-0">
          <li className="list-inline-item edit">
            <button
              type="button"
              className="btn btn-sm btn-outline-primary d-inline-flex align-items-center edit-item-btn"
              disabled={!isAdmin}
              style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
              onClick={(e) => {
                e.preventDefault();
                setEditItem(row);
                document.getElementById("addbt453").click();
              }}
            >
              <i className="ri-pencil-fill fs-16 me-1"></i> Edit
            </button>
          </li>
          <li className="list-inline-item">
            <button
              type="button"
              className="btn btn-sm btn-outline-danger d-inline-flex align-items-center remove-item-btn"
              disabled={!isAdmin}
              style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
              onClick={(e) => {
                e.preventDefault();
                delItem(row);
              }}
            >
              <i className="ri-delete-bin-5-fill fs-16 me-1"></i> Delete
            </button>
          </li>
        </ul>
      ),
      ignoreRowClick: true,
      width: '220px',
    },
  ];

  // Custom styles to match your existing theme
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: '#f3f6f9',
        textTransform: 'uppercase',
        color: '#878a99',
        fontWeight: '600',
        fontSize: '12px',
      },
    },
    rows: {
      style: {
        fontSize: '14px',
      },
    },
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="orderList">
              <div className="card-header border-0">
                <div className="row align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Department List</h5>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                      <button id="addbt453" style={{ display: "none" }} type="button" className="btn btn-success add-btn" data-bs-toggle="modal" data-bs-target="#showModal"></button>
                      <button type="button" className="btn btn-success add-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          setEditItem(null);
                          document.getElementById("addbt453").click();
                        }}
                      >
                        <i className="ri-add-line align-bottom me-1"></i> Add Department
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body border border-dashed border-end-0 border-start-0">
                <div className="row g-3">
                  <div className="col-xxl-5 col-sm-6">
                    <div className="search-box">
                      <input className="form-control search" name="search_key" onChange={handleChange} value={formData.search_key} placeholder="Search by name..." type="text" />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body pt-0">
                <DataTable
                  columns={columns}
                  data={filteredList}
                  pagination
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[10, 25, 50, 100]}
                  selectableRows
                  customStyles={customStyles}
                  highlightOnHover
                  noDataComponent={
                    <div className="text-center text-muted py-4">No matching results found.</div>
                  }
                />
                <AddDepart item={editItem} onAddDepart={handleAddDepart} />
                <DelBox />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Departments;